<template>
  <div
    class="d-flex justify-start flex-column"
    :style="{
      backgroundColor: '#F4F4F4',
      borderRadius: $getScaledCssValue('6px'),
      padding: `${$getScaledCssValue('29px')} ${$getScaledCssValue(
        '29px'
      )} 0 ${$getScaledCssValue('21px')}`
    }"
  >
    <template v-if="filterItems">
      <v-menu
        offset-y
        :close-on-content-click="false"
        v-for="(filterItem, index) in filterItems"
        :key="index"
      >
        <template #activator="{ on, attrs, value }">
          <div
            class="d-flex align-baseline filter-menu-activator"
            :class="{ 'filter-menu-activator-open': value }"
            :style="{
              marginBottom: '2px'
            }"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary" :size="14">mdi-plus-box</v-icon>

            <div
              class="filter-item-label text-p3"
              :style="{
                marginLeft: $getScaledCssValue('6px')
              }"
            >
              {{ filterItem.label }}
            </div>

            <!--
            <v-icon
              class="filter-label-arrow"
              :class="{
                'filter-label-arrow-open': value
              }"
              >mdi-chevron-down</v-icon
            >
            -->
          </div>

          <!--<v-divider class="mt-1" />-->
        </template>

        <div
          :style="{
            padding: `${$getScaledCssValue('16px')}`,
            backgroundColor: 'white'
          }"
        >
          <TextField
            @input="$emit('filterItemSearchTermUpdated', filterItem)"
            v-model="filterItem.searchTerm"
            label="Search"
            dense
            :showSuccess="false"
            class="text-p5 textfield"
            :style="{ width: '100%' }"
          />

          <v-virtual-scroll
            :items="filterItem.visibleItems"
            :height="getScrollerHeight(filterItem.visibleItems)"
            :item-height="itemHeight"
            min-width="400"
          >
            <template #default="{ item }">
              <div
                :key="item.value"
                :style="{ height: `${itemHeight}px`, overflow: 'hidden' }"
              >
                <Checkbox
                  :val="item.value"
                  class="filter-checkbox checkbox"
                  dense
                  v-model="filterItem.value"
                  color="green"
                  @change="$emit('filterChanged')"
                >
                  <template #label>
                    <div class="text-p4 checkbox-label d-flex">
                      {{ item.text }}
                    </div>
                  </template>
                </Checkbox>
              </div>
            </template>
          </v-virtual-scroll>
        </div>
      </v-menu>
    </template>

    <template v-else>
      <SkeletonLoader
        v-for="n in 6"
        :key="n"
        type="text"
        :style="{
          marginBottom: '2px'
        }"
      />
    </template>
  </div>
</template>

<script>
import Checkbox from './Checkbox.vue';
import AutoComplete from '../inputs/AutoComplete.vue';
import TextField from '../inputs/TextField.vue';
import SkeletonLoader from '../Utils/SkeletonLoader.vue'
export default {
  components: {
    Checkbox,
    AutoComplete,
    TextField,
    SkeletonLoader
  },
  props: {
    filterItems: {
      default: null
    }
  },
  data() {
    return {
      itemHeight: 32
    }
  },

  methods: {
    getScrollerHeight(items) {
      const numberOfItems = items.length
      const maxNumberOfItems = 5

      if (numberOfItems < maxNumberOfItems) {
        return numberOfItems * this.itemHeight
      } else {
        return maxNumberOfItems * this.itemHeight
      }
    },
    filter() {
      const selectedFilters = []
      this.filterItems.forEach((item) => {
        selectedFilters.push({
          title: item.title,
          selectedFilters: item.selectedFilters
        })
      })
    }
  },

  watch: {
    /*
    filterItems: {
      deep: true,
      handler() {
        const selectedFilters = []
        this.filterItems.forEach((item) => {
          selectedFilters.push({
            title: item.title,
            selectedFilters: item.selectedFilters
          })
        })
      }
    }
    */
  }
}
</script>

<style scoped lang="scss">
// @import '~Scss/variables.scss';

.list-group >>> .v-list-group__header__prepend-icon {
  margin-right: 8px !important;
}

.list-group >>> .v-list-group__header__append-icon {
  margin-left: 8px !important;
  min-width: 28px !important;
}

.list-group >>> .v-list-group__header {
  padding-left: 4px;
  padding-right: 4px;
}

.filter-checkbox >>> .v-messages {
  min-height: 0;
}

.filter-checkbox >>> .v-input--checkbox {
  margin-top: 0;
  padding-top: 0;
}

.filter-item + .filter-item {
  margin-top: 8px;
}

.checkbox-label {
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*
.filter-item-label {
  margin-top: 8px;
}
*/
.filter-label-arrow {
  transition: transform 300ms;
}

.filter-label-arrow-open {
  transform: rotate(180deg);
}

.filter-menu-activator {
  transition: background-color 300ms;
}

.filter-menu-activator-open {
  background-color: var(--v-background-base, white);
}

.textfield::v-deep {
  & input {
    font-size: #{20px * 0.8};
  }

  & label {
    font-size: #{20px * 0.8};
  }
}

.checkbox::v-deep {
  & .v-input {
    margin-top: 0;
    padding-top: 0;
  }

  & .v-input__slot {
    margin-bottom: 0;
  }
}
</style>
